import React from "react";
import {
  Grid,
  TextField,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Divider,
  IconButton,
  Dialog,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../globalStyles/fonts";
import { disabledFieldSx } from "../../constants/fieldStyles";

const ProfileAssumptionDetailsModal = ({
  profileAssumption,
  open,
  onClose,
}) => {
  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <DialogTitle
            fontSize={"20px"}
            fontFamily={"poppins"}
            fontWeight={500}
            color={"var(--text-tertiary)"}
          >
            {"Profile Assumption Details"}
          </DialogTitle>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
            }}
          >
            <IconButton onClick={onClose}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <Divider style={{ marginBottom: "10px" }} />
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <CustomTypography>Profile</CustomTypography>
              <TextField
                size="small"
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={profileAssumption?.profile?.item || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTypography>Safety Stock Weeks</CustomTypography>
              <TextField
                size="small"
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={profileAssumption?.safetyStockWeeks || ""}
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <CustomTypography>Loss Rate</CustomTypography>
              <TextField
                size="small"
                margin="dense"
                variant="outlined"
                type="text"
                fullWidth
                value={
                  profileAssumption?.lossRate
                    ? `${profileAssumption.lossRate}%`
                    : ""
                }
                InputProps={{
                  readOnly: true,
                }}
                sx={disabledFieldSx}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProfileAssumptionDetailsModal;
